export default "__VITE_ASSET__BN7l5atn__"